import { motion, useIsPresent } from "framer-motion"
import { useEffect, useLayoutEffect, useMemo } from "react"
import Footer from "../components/Footer"
import WorksNav from "../components/WorksNav"
import useGlobalContext from "../context/GlobalContext"
import { title, titleLetter } from "./Work"
import data from "../data/project.json"
import { useLocation, useNavigate } from "react-router-dom"
import { useLocomotiveScroll } from "react-locomotive-scroll"

const Works = () => {
  const { scroll } = useLocomotiveScroll()
  const location = useLocation()
  const navigate = useNavigate()
  const isPresent = useIsPresent()
  const { changeCursor, activeLink } = useGlobalContext()

  useEffect(() => {
    if (!scroll) return
    scroll.scrollTo("top", {
      offset: 0,
      duration: 600,
      easing: [0.25, 0.0, 0.35, 1.0],
      // disableLerp: true,
    })
  }, [activeLink, scroll])

  useLayoutEffect(() => {
    window.scroll({ top: 0, behavior: "instant" })
  }, [])

  const filteredProjects = useMemo(() => {
    if (activeLink === 0) {
      return data.projects
    } else if (activeLink === 1) {
      return data.projects.filter((proj) => proj.type === "short film")
    } else if (activeLink === 2) {
      return data.projects.filter((proj) => proj.type === "music video")
    } else {
      return data.projects.filter((proj) => proj.type === "commercial")
    }
  }, [activeLink])

  return (
    <>
      <motion.div
        initial={{ scaleY: 2 }}
        animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
        exit={{ scaleY: 2, transition: { duration: 0.5, ease: "circIn" } }}
        style={{ originY: isPresent ? 0 : 1 }}
        className="privacy-screen"
      />
      <WorksNav />
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{
          opacity: 0,
        }}
        transition={{ duration: 0.5 }}
        onMouseEnter={() => changeCursor("")}
        className="works"
        data-scroll-section
      >
        <motion.h1
          key={activeLink}
          variants={title}
          initial="closed"
          viewport={{ once: true }}
          whileInView="open"
          className="title proj-title container"
        >
          {Array.from(
            `${
              activeLink === 0
                ? "All Work"
                : activeLink === 1
                ? "Narrative"
                : activeLink === 2
                ? "Music videos"
                : "Commercials"
            }`
          ).map((l, i) => (
            <motion.span variants={titleLetter} key={i}>
              {l}
            </motion.span>
          ))}
        </motion.h1>
        <motion.div
          key={filteredProjects.length + 5}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
          className="main-grid-container"
          onMouseLeave={() => changeCursor("")}
          onMouseEnter={() => changeCursor("img-hover")}
        >
          {filteredProjects.map((proj, i) => (
            <motion.div
              onClick={() =>
                navigate(`/work/${proj.title}`, {
                  state: { proj, from: location.pathname },
                })
              }
              key={proj.title}
              className={`img-container p-relative g-${i + 1}`}
            >
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 1 } }}
                className="par uppercase float-txt mix-blend-difference"
              >
                {proj.title}
              </motion.p>
              <img src={proj.img} alt="" loading="lazy" decoding="async" />
            </motion.div>
          ))}
        </motion.div>
      </motion.section>
      <Footer contain />
    </>
  )
}

export default Works
